"use strict";
/*
 * Created on 11 02 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Represents binding of {@link Product product} to {@link InternalSite internal site}. This is the most relevant
 * source to determine validity of product to the system across all {@link PriceZone price zones}.
 *
 * The flag across all price zones ({@see Product.active} is determined during data import to the system. You should
 * use the binding only if you need to determine whether a product is active within specific price zone (group of sites).
 *
 * JMe: Consider to add Product.active and Product.categoryIds attributes to the entity to optimize queries.
 *
 * @author JMe
 */


var ProductSiteBinding =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductSiteBinding, _DomainObject_1$Domai);

  /**
   * @param id the internal id
   * @param productId the internal id of product
   * @param siteId the internal site id
   * @param validFrom start of validity of site in the group of site
   * @param validTo end of validity of site in the group of site
   * @param processed defines whether an instance was processed
   */
  function ProductSiteBinding(id, productId, siteId, validFrom, validTo, processed) {
    var _this;

    _classCallCheck(this, ProductSiteBinding);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSiteBinding).call(this));
    _this.id = id;
    _this.productId = productId;
    _this.siteId = siteId;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.processed = processed;
    return _this;
  }

  return ProductSiteBinding;
}(DomainObject_1.DomainObject);

exports.ProductSiteBinding = ProductSiteBinding;

ProductSiteBinding.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductSiteBinding.name);
  return {
    id: builder.id('id'),
    siteId: builder.id('siteId'),
    productId: builder.id('productId'),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN),
    processed: builder.bool('processed')
  };
}();